import { NumberInput, NumberInputField } from "@chakra-ui/react";
import { CustomDatePickerProps } from "./CustomDatePicker";
import { DATE_KEYS, DateItemType } from "@lubbezposrednio-frontend/core";

type DateInputProps = Omit<CustomDatePickerProps, "label"> & {
  dateItem: DateItemType;
};

export const DateInput: React.FC<DateInputProps> = ({ dateItem, value, onChange, onBlur, ...props }) => {
  const isYear = dateItem.key === DATE_KEYS.YEAR;

  return (
    <NumberInput
      variant="custom"
      bg="white"
      borderColor="rgba(67,0,152,0.16)"
      opacity={props.isDisabled ? "0.5" : "1"}
      borderWidth="1.5px"
      borderRadius="10px"
      _hover={{ borderColor: "rgba(67,0,152,0.32)" }}
      _focusWithin={{ borderColor: "primary", boxShadow: "0 0 0 1px var(--chakra-colors-primary)" }}
      w={dateItem.width ?? "52px"}
      display="flex"
      alignItems="center"
      onChange={val => onChange(dateItem.key, val)}
      value={value[dateItem.key]}
      onBlur={onBlur}
      ml={{ base: isYear ? "5px" : 0, sm: 0 }}
      {...props}
    >
      <NumberInputField
        bg="transparent"
        placeholder={dateItem.placeholder}
        p={0}
        textAlign="center"
        maxLength={isYear ? 4 : 2}
        h="38px"
        _placeholder={{ color: "gray.400" }}
      />
    </NumberInput>
  );
};
